import axios from '@/axiosInterceptor';
import ENV from '../../config';

const state = () => ({
  token: null,
  nonce: null,
  paymentInformation: null,
  clientInstance: null,
  HostedFieldInstance: null,
  actualPlan: null,
  braintreeError: false,
  focusPlan: null,
  paymentUpdated: null,
  counterFields: 0,
  counterFieldsValid: 0,
  counterFieldsPotentiallyValid: 0,
  counterFieldsTotalValidOrPValid: 0,
  formValid: false,
  formSubmitting: false,
});

const actions = {
  async getCurrentPaymentMethod({ commit }) {
    try {
      let res = await axios.get(
        `${ENV.API.IDENTITY}/api/v1/billing/current_payment_methods`
      );

      commit('setActualPlan', res.data.plan);

      //If the user has more than one Card, verifying default properties
      if (res.data.payment_methods.length > 1) {
        res.data.payment_methods.forEach((card) => {
          if (card.is_default) {
            commit('setPaymentInformation', card);
          }
        });
      } else {
        commit('setPaymentInformation', res.data.payment_methods);
      }
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async changeOrSelectPlan({ state, commit }) {
    const plan = state.focusPlan;
    try {
      let res = await axios.patch(
        `${ENV.API.IDENTITY}/api/v1/billing/change_plan`,
        {
          plan_id: plan,
        }
      );
      commit('setActualPlan', res.data.plan);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async addPaymentMethod({ commit, state }) {
    const nonce = state.nonce;
    console.log(state.focusPlan);
    try {
      let res = await axios.patch(
        `${ENV.API.IDENTITY}/api/v1/billing/add_payment_method`,
        { nonce: nonce, plan_id: state.focusPlan }
      );
      commit('setPaymentUpdated', res);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  setSelectedPlan({ commit }, plan) {
    commit('setFocusPlan', plan);
  },
};
const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  setPaymentInformation(state, information) {
    state.paymentInformation = information;
  },
  setNonce(state, nonce) {
    state.nonce = nonce;
  },
  setClientIntance(state, instance) {
    state.clientInstance = instance;
  },
  setHostedFieldInstance(state, HostedFieldInstance) {
    state.HostedFieldInstance = HostedFieldInstance;
  },
  setActualPlan(state, actualPlan) {
    state.actualPlan = actualPlan;
  },
  setBraintreeError(state) {
    state.braintreeError = true;
  },
  setFocusPlan(state, plan) {
    state.focusPlan = plan;
  },
  setPaymentUpdated(state, payment) {
    state.paymentUpdated = payment;
  },
  setCounter(state) {
    state.counterFields += 1;
  },
  setCounterValid(state) {
    state.counterFieldsValid += 1;
  },
  setCounterPotentiallyValid(state) {
    state.counterFieldsPotentiallyValid += 1;
  },
  setCounterTotalValidOrPValid(state) {
    state.counterFieldsTotalValidOrPValid += 1;
  },
  setFormValidTrue(state) {
    state.formValid = true;
  },
  setFormValidFalse(state) {
    state.formValid = false;
  },
  setFormSubmittingTrue(state) {
    state.formSubmitting = true;
  },
  setFormSubmittingFalse(state) {
    state.formSubmitting = false;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
